import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { wayToPayType, WayToPay } from '../../types/slices/wayToPayType'

const initialState: wayToPayType =
{
    status: ApiStatus.FETCHED,
    wayToPay: [],
    wayToPaySelected: {} as WayToPay,
    errorMessage: undefined,
    action: ''
}

const wayToPaySlice = createSlice({
    name: 'wayToPaySlice',
    initialState,
    reducers: {
        onFetchWayToPay (state, { payload }: { payload: WayToPay[]}) {
        state.status = ApiStatus.FETCHED
        state.wayToPay = payload
        state.errorMessage = undefined
        },
        onSetSelectedWayToPay (state, { payload }: { payload: WayToPay }) {
        state.wayToPaySelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectWayToPayState = (state: RootState) => state.wayToPaySlice
export default wayToPaySlice.reducer
export const {
    onFetchWayToPay,
    onSetSelectedWayToPay,
    changeStatus,
    setAction,
} = wayToPaySlice.actions
